import Routing        from "../app/router";
import LoginBaseModel from "./login-base-model";

class ResetExtranetPasswordModel extends LoginBaseModel
{
    resetPassword(login, email)
    {
        return new Promise((resolve, reject) => {
            $.ajax({
                       url  : Routing.generate('session_reset_password_extranet_send'),
                       data : { login, email },
                   }).then(resolve, reject);
        })
    }

}
export default ResetExtranetPasswordModel;